import React, { Component } from 'react';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

class ScrollArrow extends Component {
  slideTo = (direction) => {
    const position = 200;
    const {
      target,
      vertical,
    } = this.props;
    let { scrollTop } = document.querySelector(target);

    if (vertical) {
      let { scrollLeft } = document.querySelector(target);
      const scroll = direction === 'left' ? scrollLeft -= position : scrollLeft += position;
      document.querySelector(target).scrollTo({
        top: 0,
        left: scroll,
        behavior: 'smooth',
      });
      return true;
    }

    const scroll = direction === 'left' ? scrollTop -= position : scrollTop += position;

    document.querySelector(target).scrollTo({
      top: scroll,
      left: 0,
      behavior: 'smooth',
    });
  }

  render() {
    const {
      direction,
      classes,
    } = this.props;

    const scroll = direction === 'left' ? 'ScrollLeft' : 'ScrollRight';

    return (
      <div className={`${scroll} ${classes}`}>
        <i
          className={`fa fa-arrow-${direction}`}
          onClick={() => this.slideTo(direction)}
        />
      </div>
    );
  }
}

export default ScrollArrow;



// WEBPACK FOOTER //
// ./src/components/scroll-arrow/ScrollArrow.jsx